

























































































import { Watch, Component, Prop, Vue } from 'vue-property-decorator'
import { Pipeline } from '@/api/model/pipeline'
import { BranchOperatingZoneAPI, PipelineAPI } from '@/api/backend-client'
import { Branch } from '@/api/model/branch'
import { BranchOperatingZone } from '@/api/model/branch-operating-zone'
import { v4 as uuid } from 'uuid'

@Component
export default class CreateBranchOperatingZonesModal extends Vue {

    @Prop({ type: Boolean, default: false }) value!: boolean
    branchOperatingZones: BranchOperatingZone[] = []
    pipelines: Pipeline[] = []
    visible: boolean = false
    loading: boolean = false

    pipelineId: string = null
    branch: Branch = null
    areaCodes: string = null

    @Watch('value')
    onValueChanged(): void {
        this.visible = this.value
    }

    @Watch('visible')
    onVisibleChanged(): void {
        this.$emit('input', this.visible)
    }

    @Watch('pipelineId')
    watchPipelineId(): void {
        this.branch = null
    }

    async mounted(): Promise<void> {
        await this.loadLocalValues()

        if (this.availablePipelines.length > 0) {
            this.pipelineId = this.availablePipelines[0].id
        }
    }

    async loadLocalValues(): Promise<void> {
        this.loading = true

        this.branchOperatingZones = await BranchOperatingZoneAPI.getAll({
            'pipeline.company': this.$currentCompany.resourceIdentifier,
        })

        this.pipelines = await PipelineAPI.getAll({
            company: this.$currentCompany.resourceIdentifier,
            active: 1,
        })

        this.loading = false
    }

    async saveOperatingZones(): Promise<void> {
        this.loading = true

        const promises = []

        this.areaCodesResult.forEach(areaCode => {
            if (!this.excludedAreaCodes.includes(areaCode)) {
                promises.push(BranchOperatingZoneAPI.create(new BranchOperatingZone(
                    this.pipeline,
                    this.branch,
                    uuid(),
                    Number.parseInt(areaCode, 10),
                )))
            }
        })

        await Promise.all(promises)

        this.$emit('save', {
            pipeline: this.pipeline,
            branch: this.branch,
        })

        this.hideModal()

        this.loading = false
    }

    hideModal(): void {
        this.visible = false
    }

    get excludedAreaCodes(): string[] {
        if (!this.branch || !this.pipelineId) {
            return []
        }

        return this.branchOperatingZones
            .filter(operatingZone => {
                return operatingZone.pipeline.id === this.pipelineId &&
                operatingZone.branch.id === this.branch.id
            }).map(operatingZone => operatingZone.areaCode.toString())
    }

    get areaCodesResult(): string[] {
        return this.areaCodes
            .trim()
            .split(',')
            .filter((value, index, self) => self.indexOf(value) === index)
    }

    get availablePipelines(): Pipeline[] {
        return this.pipelines
            .sort((a: Pipeline, b: Pipeline) => a.name.localeCompare(b.name))
    }

    get pipelineOptions(): Array<{label: string, value: string}> {
        return this.availablePipelines.map(pipeline => {
            return {
                label: pipeline.name,
                value: pipeline.id,
            }
        })
    }

    get pipeline(): null|Pipeline {
        if (!this.pipelineId) {
            return null
        }

        return this.availablePipelines.find(pipeline => pipeline.id === this.pipelineId)
    }

    get availableBranches(): Branch[] {
        if (!this.pipeline) {
            return []
        }

        return this.pipeline.branches
    }
}
